import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import Modal from 'react-modal';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

Modal.setAppElement('#root');

const Faculty = () => {
    const [facultyData, setFacultyData] = useState({});
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedImg, setSelectedImg] = useState(null);
    const { dept } = useParams();

    useEffect(() => {
        fetch('/data/facultyData.json')
            .then(res => res.json())
            .then(data => {
                const department = data.find(item => item.code === dept);
                console.log("Fetched Labs:", department?.labs);
                setFacultyData(department || {});
            });
    }, [dept]);

    const PrevArrow = ({ onClick }) => (
        <div className="absolute top-1/2 left-4 transform -translate-y-1/2 text-white text-2xl cursor-pointer z-10 bg-transparent p-2 rounded-full hover:bg-gray-700 transition-all duration-300" onClick={onClick}>
            <FaArrowLeft />
        </div>
    );

    const NextArrow = ({ onClick }) => (
        <div className="absolute top-1/2 right-4 transform -translate-y-1/2 text-white text-2xl cursor-pointer z-10 bg-transparent p-2 rounded-full hover:bg-gray-700 transition-all duration-300" onClick={onClick}>
            <FaArrowRight />
        </div>
    );

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    };

    return (
        <section>
            <div className='page-header h-72'>
                <h1 className='text-3xl md:text-5xl uppercase font-bold text-white text-center my-8'>{facultyData?.name}</h1>
            </div>

            <div className='container mx-auto'>
                <div className='my-12 mx-4 text-justify'>
                    {[...Array(7).keys()].map(i => (
                        facultyData[`description${i + 1}`] && <p key={i} className='py-2'>{facultyData[`description${i + 1}`]}</p>
                    ))}
                </div>

                {/* Faculty Profiles */}
                {facultyData.facultyMembers && facultyData.facultyMembers.length > 0 && (
                    <div className='my-12'>
                        <h1 className='text-3xl font-bold text-center text-secondary'>FACULTY MEMBERS</h1>
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-6'>
                            {facultyData.facultyMembers.map((member, i) => (
                                <div key={i} className='bg-white p-4 shadow-lg rounded-lg text-center'>
                                    <img src={member.image} alt={member.name} className='w-32 h-32 mx-auto rounded-full object-cover' />
                                    <h2 className='text-xl font-semibold mt-4'>{member.name}</h2>
                                    <p className='text-gray-600'>{member.designation}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Lab & Infrastructure Slider */}
                {facultyData.labs && facultyData.labs.length > 0 && (
                    <div className='my-12'>
                        <h1 className='text-3xl font-bold text-center text-secondary'>LAB & <span className='text-primary'>INFRASTRUCTURE</span></h1>
                        <Slider {...settings} className="space-x-4">
    {facultyData.labs.map((lab, i) => (
        <div key={i} className="px-2"> {/* Adds padding around each slide */}
            <div 
                className="relative w-full h-64 flex justify-center items-center bg-gray-200 overflow-hidden group cursor-pointer" 
                onClick={() => { setSelectedImg(lab.labImage); setModalIsOpen(true); }}
            >
                <img src={lab.labImage} alt={lab.labName} className="w-full h-full object-cover rounded-lg transition-transform duration-300 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
                <h2 className='absolute bottom-4 text-primary text-xl  font-bold'>{lab.labName}</h2>
            </div>
        </div>
    ))}
</Slider>
                    </div>
                )}
            </div>

            {/* Modal for full view */}
            <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80">
                {selectedImg && (
                    <div className="relative p-4 max-w-4xl w-full">
                        <button className="absolute top-2 right-2 text-white text-3xl" onClick={() => setModalIsOpen(false)}>&times;</button>
                        <img src={selectedImg} alt="Full view" className="w-full max-h-screen object-contain rounded-lg" />
                    </div>
                )}
            </Modal>
        </section>
    );
};

export default Faculty;
